<template>
  <div class="system">
      <div class="content" >
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="图类型管理" name="first">
            <div class="btn" >
                <el-button type="primary" @click="addType">新增</el-button>
            </div>
            <div   ref="myHeight" class="mytable">
                <el-table
                    :data="typeData"
                    align='center'
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="类型">
                    </el-table-column>
                    <el-table-column label="操作" align='center'>
                        <template slot-scope="scope" >
                            <el-button
                            size="mini"
                            type="danger"
                            @click="delType(scope.$index, scope.row)">删除</el-button>
                            <!-- <el-button
                            size="mini"
                            type="primary"
                            @click="updateType(scope.$index, scope.row)">编辑</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            </el-tab-pane>
            <el-tab-pane label="连接线管理" name="second">
                <div class="btn">
                    <el-button type="primary" @click="addLine">新增</el-button>
                </div>
                <div ref="myHeight">
                    <el-table
                        :data="lineData"
                        align='center'
                        style="width: 100%">
                        <el-table-column
                            prop="linename"
                            label="名称">
                        </el-table-column>
                        <el-table-column label="操作" align='center'>
                            <template slot-scope="scope" >
                                <el-button
                                size="mini"
                                type="danger"
                                @click="delLine(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
      </div>
      <div>
          <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="480px"
            :before-close="handleClose">
            <div class="dialog">
                <div>名称</div>
                <div>
                    <el-input placeholder="请输入" v-model="inputValue" clearable></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="enSure">确 定</el-button>
            </span>
          </el-dialog>
      </div>
  </div>
</template>
<script>
export default {
    data () {
      return {
          activeName:"first",
          typeData:[],
          lineData:[],
          title:"",
          dialogVisible:false,
          inputValue:'',
          type:'',//1:新增类型 2:新增线 3:修改类型
          typeId:"",
          clientHeight:"",
     }
   },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        this.changeFixed(this.clientHeight)
      },
    },
    mounted(){
        this.getLine()
        this.getAllType()
        this.clientHeight =   `${document.documentElement.clientHeight}`-220         
        window.onresize = function temp() {
            this.clientHeight = `${document.documentElement.clientHeight}`-220 ;
      };
    },
    methods:{
        handleClick(tab,event){
              //console.log(tab, event);
        },
        //
        getAllType(){
            this.$api.getAllMapType({},res=>{
                this.typeData=res.data
            })
        },
        getLine(){
            this.$api.getLine({},res=>{
                this.lineData=res.data
            })
        },
        handleClose(){
            this.dialogVisible=false
        },
        addType(){
            this.dialogVisible=true
            this.title="新增图类型"
            this.type=1
            this.inputValue=''
        },
        addLine(){
            this.dialogVisible=true
            this.title="新增接线类型"
            this.type=2
            this.inputValue=''
        },
        enSure(){
            this.dialogVisible=false
            if(this.type==1){
                this.$api.addMapType({name:this.inputValue},res=>{
                    if(res.errCode==0){
                        this.getAllType()
                        this.$message({
                            type:"success",
                            message:"新增成功"
                        })
                    }else{
                        this.$message.error("新增失败")
                    }
                })
            }else if(this.type==2){
                this.$api.addLine({linename:this.inputValue},res=>{
                    if(res.errCode==0){
                        this.getLine()
                        this.$message({
                            type:"success",
                            message:"新增成功"
                        })
                    }else{
                        this.$message.error("新增失败")
                    } 
                })
            }else{
                this.$api.updateMapType({name:this.inputValue,id:this.typeId},res=>{
                    if(res.errCode==0){
                        this.getAllType()
                        this.$message({
                            type:"success",
                            message:"修改成功"
                        })
                    }else{
                        this.$message.error("修改失败")
                    }
                })
            }
        },
        delType(index,row){
            this.$confirm('是否删除该数据', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$api.delMapType({id:row.id},res=>{
                        if(res.errCode==0){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getAllType()
                        }
                    })
            })
        },
        updateType(index,row){
            this.dialogVisible=true;
            this.inputValue=row.name
            this.type=3
            this.typeId=row.id
        },
        delLine(index,row){
            this.$confirm('是否删除该数据', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$api.delLine({id:row.id},res=>{
                        if(res.errCode==0){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getLine()
                        }
                    })
            })
        },
        changeFixed(clientHeight){ //动态修改样式
        this.$refs.myHeight.style.maxHeight = clientHeight+'px';
      },
    }
}

</script>
<style scoped>
.content{
    width: 800px;
    margin: 0 auto;
}
.btn{
    text-align: right;
    margin-bottom: 10px;
    height: 50px;
    background-color: #fff;
    padding-top: 10px;
    padding-right: 50px;
}
.dialog{
    display: flex;
    line-height: 40px;
}
.dialog>div:first-child{
    margin-right: 20px;
    font-size: 16px;
}
.mytable{
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/system.vue